import { BoxReportBloc } from "./bloc.box";
import { CloudReportBloc } from "./bloc.cloud";
import { getService } from "@cems-eco/core/src/utils/platform";
import { BaseReportBloc } from "./bloc.base";
import environment from "@/config";

export default getService<BaseReportBloc>(environment.nexus, {
    box: new BoxReportBloc(),
    cloud: new CloudReportBloc(),
});